import { Link, Head } from "@inertiajs/react"
import { Button } from "@/components/ui/button"

export default function Home() {
  return (
    <>
      <Head title="IUPAT Portal">
        <meta
          name="description"
          content="The internal home for IUPAT staff tools — automated member texts, weekly activity reports, and BUMP training records, all behind your IUPAT sign-in."
        />
        <meta property="og:title" content="IUPAT Portal" />
        <meta
          property="og:description"
          content="The internal home for IUPAT staff tools — automated member texts, weekly activity reports, and BUMP training records, all behind your IUPAT sign-in."
        />
      </Head>
      <main className="mx-auto flex min-h-screen max-w-2xl flex-col items-center justify-center px-4 py-16 text-center">
        <h1>IUPAT Portal</h1>
        <p className="mt-2 max-w-md text-ink-muted">
          The internal home for IUPAT staff tools. Sign in with your IUPAT
          account to get started.
        </p>
        <div className="mt-6 flex items-center gap-3">
          <Button asChild>
            <Link href="/login">Sign in</Link>
          </Button>
        </div>
      </main>
    </>
  )
}
